export interface SceneBudget {
  tier: "balanced" | "high";
  pixelRatio: number;
  shadowSize: number;
  particleScale: number;
}

/** Preserve PBR materials and geometry; bound fill-rate on high-DPI/low-power devices. */
export function sceneBudget(input: { cores?: number; memoryGb?: number; pixelRatio: number; width: number }): SceneBudget {
  const constrained = (input.cores !== undefined && input.cores <= 4) ||
    (input.memoryGb !== undefined && input.memoryGb <= 4) || input.width < 768;
  return {
    tier: constrained ? "balanced" : "high",
    pixelRatio: Math.min(Math.max(1, input.pixelRatio), constrained ? 1.25 : 1.5),
    shadowSize: constrained ? 1024 : 2048,
    particleScale: constrained ? 0.65 : 1,
  };
}

/** Also works in Safari and workers without scheduler.yield. */
export async function yieldSceneWork(): Promise<void> {
  const scheduler = (globalThis as typeof globalThis & { scheduler?: { yield?: () => Promise<void> } }).scheduler;
  if (scheduler?.yield) await scheduler.yield();
  else await new Promise<void>(resolve => setTimeout(resolve, 0));
}
